// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: sensor_msgs/msg/NavSatFix.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Header } from "../../std_msgs/msg/Header";
import { NavSatStatus } from "./NavSatStatus";

export const protobufPackage = "sensor_msgs.msg.pb";

/**
 * Navigation Satellite fix for any Global Navigation Satellite System
 *
 * Specified using the WGS 84 reference ellipsoid
 */
export interface NavSatFix {
  /**
   * header.stamp specifies the ROS time for this measurement (the
   *       corresponding satellite time may be reported using the
   *       sensor_msgs/TimeReference message).
   *
   * header.frame_id is the frame of reference reported by the satellite
   *       receiver, usually the location of the antenna.  This is a
   *       Euclidean frame relative to the vehicle, not a reference
   *       ellipsoid.
   */
  header:
    | Header
    | undefined;
  /** Satellite fix status information. */
  status:
    | NavSatStatus
    | undefined;
  /** Latitude. Positive is north of equator; negative is south. */
  latitude: number;
  /** Longitude. Positive is east of prime meridian; negative is west. */
  longitude: number;
  /**
   * Altitude. Positive is above the WGS 84 ellipsoid
   * (quiet NaN if no altitude is available).
   */
  altitude: number;
  /**
   * Position covariance defined relative to a tangential plane
   * through the reported position. The components are East, North, and
   * Up (ENU), in row-major order.
   *
   * Beware: this coordinate system exhibits singularities at the poles.
   */
  position_covariance: number[];
  position_covariance_type: number;
}

export enum NavSatFix_CovarianceEnum {
  /**
   * COVARIANCE_TYPE_UNKNOWN - If the covariance of the fix is known, fill it in completely. If the
   * GPS receiver provides the variance of each measurement, put them
   * along the diagonal. If only Dilution of Precision is available,
   * estimate an approximate covariance from that.
   */
  COVARIANCE_TYPE_UNKNOWN = 0,
  COVARIANCE_TYPE_APPROXIMATED = 1,
  COVARIANCE_TYPE_DIAGONAL_KNOWN = 2,
  COVARIANCE_TYPE_KNOWN = 3,
  UNRECOGNIZED = -1,
}

export function navSatFix_CovarianceEnumFromJSON(object: any): NavSatFix_CovarianceEnum {
  switch (object) {
    case 0:
    case "COVARIANCE_TYPE_UNKNOWN":
      return NavSatFix_CovarianceEnum.COVARIANCE_TYPE_UNKNOWN;
    case 1:
    case "COVARIANCE_TYPE_APPROXIMATED":
      return NavSatFix_CovarianceEnum.COVARIANCE_TYPE_APPROXIMATED;
    case 2:
    case "COVARIANCE_TYPE_DIAGONAL_KNOWN":
      return NavSatFix_CovarianceEnum.COVARIANCE_TYPE_DIAGONAL_KNOWN;
    case 3:
    case "COVARIANCE_TYPE_KNOWN":
      return NavSatFix_CovarianceEnum.COVARIANCE_TYPE_KNOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NavSatFix_CovarianceEnum.UNRECOGNIZED;
  }
}

export function navSatFix_CovarianceEnumToJSON(object: NavSatFix_CovarianceEnum): string {
  switch (object) {
    case NavSatFix_CovarianceEnum.COVARIANCE_TYPE_UNKNOWN:
      return "COVARIANCE_TYPE_UNKNOWN";
    case NavSatFix_CovarianceEnum.COVARIANCE_TYPE_APPROXIMATED:
      return "COVARIANCE_TYPE_APPROXIMATED";
    case NavSatFix_CovarianceEnum.COVARIANCE_TYPE_DIAGONAL_KNOWN:
      return "COVARIANCE_TYPE_DIAGONAL_KNOWN";
    case NavSatFix_CovarianceEnum.COVARIANCE_TYPE_KNOWN:
      return "COVARIANCE_TYPE_KNOWN";
    case NavSatFix_CovarianceEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseNavSatFix(): NavSatFix {
  return {
    header: undefined,
    status: undefined,
    latitude: 0,
    longitude: 0,
    altitude: 0,
    position_covariance: [],
    position_covariance_type: 0,
  };
}

export const NavSatFix: MessageFns<NavSatFix> = {
  encode(message: NavSatFix, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(1939194666).fork()).join();
    }
    if (message.status !== undefined) {
      NavSatStatus.encode(message.status, writer.uint32(3624117762).fork()).join();
    }
    if (message.latitude !== 0) {
      writer.uint32(147252977).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(789321665).double(message.longitude);
    }
    if (message.altitude !== 0) {
      writer.uint32(3730171201).double(message.altitude);
    }
    writer.uint32(2623579090).fork();
    for (const v of message.position_covariance) {
      writer.double(v);
    }
    writer.join();
    if (message.position_covariance_type !== 0) {
      writer.uint32(4211924376).uint32(message.position_covariance_type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NavSatFix {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNavSatFix();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 242399333: {
          if (tag !== 1939194666) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 453014720: {
          if (tag !== 3624117762) {
            break;
          }

          message.status = NavSatStatus.decode(reader, reader.uint32());
          continue;
        }
        case 18406622: {
          if (tag !== 147252977) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 98665208: {
          if (tag !== 789321665) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 466271400: {
          if (tag !== 3730171201) {
            break;
          }

          message.altitude = reader.double();
          continue;
        }
        case 327947386: {
          if (tag === 2623579089) {
            message.position_covariance.push(reader.double());

            continue;
          }

          if (tag === 2623579090) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.position_covariance.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 526490547: {
          if (tag !== 4211924376) {
            break;
          }

          message.position_covariance_type = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NavSatFix {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      status: isSet(object.status) ? NavSatStatus.fromJSON(object.status) : undefined,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : 0,
      position_covariance: globalThis.Array.isArray(object?.positionCovariance)
        ? object.positionCovariance.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.position_covariance)
        ? object.position_covariance.map((e: any) => globalThis.Number(e))
        : [],
      position_covariance_type: isSet(object.positionCovarianceType)
        ? globalThis.Number(object.positionCovarianceType)
        : isSet(object.position_covariance_type)
        ? globalThis.Number(object.position_covariance_type)
        : 0,
    };
  },

  toJSON(message: NavSatFix): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.status !== undefined) {
      obj.status = NavSatStatus.toJSON(message.status);
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.altitude !== 0) {
      obj.altitude = message.altitude;
    }
    if (message.position_covariance?.length) {
      obj.positionCovariance = message.position_covariance;
    }
    if (message.position_covariance_type !== 0) {
      obj.positionCovarianceType = Math.round(message.position_covariance_type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NavSatFix>, I>>(base?: I): NavSatFix {
    return NavSatFix.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NavSatFix>, I>>(object: I): NavSatFix {
    const message = createBaseNavSatFix();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.status = (object.status !== undefined && object.status !== null)
      ? NavSatStatus.fromPartial(object.status)
      : undefined;
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.altitude = object.altitude ?? 0;
    message.position_covariance = object.position_covariance?.map((e) => e) || [];
    message.position_covariance_type = object.position_covariance_type ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
